import { empty, tail as tail_1, cons, head as head_1, isEmpty } from "./.fable/fable-library.3.2.9/List.js";

export function rev(list) {
    const loop = (acc_mut, _arg1_mut) => {
        loop:
        while (true) {
            const acc = acc_mut, _arg1 = _arg1_mut;
            if (!isEmpty(_arg1)) {
                acc_mut = cons(head_1(_arg1), acc);
                _arg1_mut = tail_1(_arg1);
                continue loop;
            }
            else {
                return acc;
            }
            break;
        }
    };
    return loop(empty(), list);
}

